// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jobdetails-card h6,
.jobdetails-card small {
  font-size: 0.75rem;
  text-align: center;
}
.jobdetails-card .row:nth-of-type(2) i {
  color: #0a65cc;
  font-size: 1.5rem;
}
.jobdetails-card .row:nth-of-type(2) .col > div {
  height: 49px;
}
.jobdetails-card .row:nth-of-type(3) a:hover {
  background-color: #cee0f5;
  border: 1px solid #cee0f5;
  color: #0851a3;
}

.jobdetails-offcanvas h6,
.jobdetails-offcanvas small {
  font-size: 0.75rem;
  text-align: center;
}
.jobdetails-offcanvas .row:nth-of-type(2) i {
  color: #0a65cc;
  font-size: 1.5rem;
}
.jobdetails-offcanvas .row:nth-of-type(2) .col > div {
  height: 49px;
}
.jobdetails-offcanvas .row:nth-of-type(3) a:hover {
  background-color: #cee0f5;
  border: 1px solid #cee0f5;
  color: #0851a3;
}

.share-button {
  background-color: #4D90FD;
  border: 1px solid #cee0f5;
  color: #fefefe;
  padding: 5px 13px;
  font-weight: 100;
}

.copy-link-wrapper {
  border: 1px solid #f5f5f5;
  background-color: #fefefe;
}

.copy-link-text {
  color: #0851a3;
}

.copy-link-input,
.copy-link-input:disabled,
.copy-link-input:active {
  background-color: #fefefe;
  border: 1px solid #f5f5f5;
  color: #000;
  padding: 5px 13px;
}`, "",{"version":3,"sources":["webpack://./../jobportal/src/components/HomeContent/JobDetails/JobDetails.scss"],"names":[],"mappings":"AACE;;EAEE,kBAAA;EACA,kBAAA;AAAJ;AAII;EACE,cAAA;EACA,iBAAA;AAFN;AAKI;EACE,YAAA;AAHN;AAQI;EACE,yBAAA;EACA,yBAAA;EACA,cAAA;AANN;;AAYE;;EAEE,kBAAA;EACA,kBAAA;AATJ;AAaI;EACE,cAAA;EACA,iBAAA;AAXN;AAcI;EACE,YAAA;AAZN;AAiBI;EACE,yBAAA;EACA,yBAAA;EACA,cAAA;AAfN;;AAoBA;EACE,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AAjBF;;AAoBA;EACE,yBAAA;EACA,yBAAA;AAjBF;;AAoBA;EACE,cAAA;AAjBF;;AAoBA;;;EAGE,yBAAA;EACA,yBAAA;EACA,WAAA;EACA,iBAAA;AAjBF","sourcesContent":[".jobdetails-card {\n  h6,\n  small {\n    font-size: 0.75rem;\n    text-align: center;\n  }\n\n  .row:nth-of-type(2) {\n    i {\n      color: #0a65cc;\n      font-size: 1.5rem;\n    }\n\n    .col > div {\n      height: 49px;\n    }\n  }\n\n  .row:nth-of-type(3) {\n    a:hover {\n      background-color: #cee0f5;\n      border: 1px solid #cee0f5;\n      color: #0851a3;\n    }\n  }\n}\n\n.jobdetails-offcanvas {\n  h6,\n  small {\n    font-size: 0.75rem;\n    text-align: center;\n  }\n\n  .row:nth-of-type(2) {\n    i {\n      color: #0a65cc;\n      font-size: 1.5rem;\n    }\n\n    .col > div {\n      height: 49px;\n    }\n  }\n\n  .row:nth-of-type(3) {\n    a:hover {\n      background-color: #cee0f5;\n      border: 1px solid #cee0f5;\n      color: #0851a3;\n    }\n  }\n}\n\n.share-button {\n  background-color: #4D90FD;\n  border: 1px solid #cee0f5;\n  color: #fefefe;\n  padding: 5px 13px;\n  font-weight: 100;\n}\n\n.copy-link-wrapper {\n  border: 1px solid #f5f5f5;\n  background-color: #fefefe;\n}\n\n.copy-link-text {\n  color: #0851a3;\n}\n\n.copy-link-input,\n.copy-link-input:disabled,\n.copy-link-input:active {\n  background-color: #fefefe;\n  border: 1px solid #f5f5f5;\n  color: #000;\n  padding: 5px 13px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
